"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineWrap = void 0;
/** @deprecated Let the browser wrap text when needed. */
var lineWrap = function (options) { return function (value) {
    var _a = __assign({ width: 80, break: '\n' }, options), width = _a.width, breakSequence = _a.break;
    var foundLines = value.split(/(?:\n|\r\n)+/).reduce(function (wrappedLines, line) {
        var originalLineWords = line.split(/\s+/).filter(function (word) { return word.length > 0; });
        if (originalLineWords.length === 0) {
            return wrappedLines;
        }
        wrappedLines.push([]);
        return originalLineWords.reduce(function (lines, word) {
            var lastLineIndex = lines.length - 1;
            var lastLineWords = lines[lastLineIndex];
            var lastLineWidthWithWord = lastLineWords.reduce(function (sum, lastLineWord) {
                return sum + lastLineWord.length;
            }, word.length + lastLineWords.length);
            if (lastLineWidthWithWord <= width || lastLineWords.length === 0) {
                lastLineWords.push(word);
            }
            else {
                lines.push([word]);
            }
            return lines;
        }, wrappedLines);
    }, []);
    return foundLines.map(function (words) { return words.join(' '); }).join(breakSequence);
}; };
exports.lineWrap = lineWrap;
//# sourceMappingURL=line-wrap.js.map